import { ScrollArea } from 'components/ScrollArea/ScrollArea';
import { Stack } from 'components/Stack/Stack';
import { BodySmall } from 'components/Text/BodySmall';
import { useI18n } from 'i18n/hooks/useI18n';
import type { CmsApiMiniSubsite } from 'modules/cms/api/types/CmsApiMiniSubsite';
import type { CmsApiSubsite } from 'modules/cms/api/types/CmsApiSubsite';
import { spacing } from 'theme/theme';

import { SubsiteLink } from './SubsiteLink';

type Props = {
  subsites: CmsApiMiniSubsite[];
  parentSubsite: CmsApiSubsite;
};

export function PostSearchIncludedSubsites({ subsites, parentSubsite }: Props) {
  const { i18n } = useI18n();

  return (
    <div data-qa-id="side-filter-facet-subsites">
      <BodySmall>{i18n('Category')}</BodySmall>
      <ScrollArea
        direction="horizontal"
        data-qa-id="search-filter-section-filters"
        hideScrollBar
        width="100%"
      >
        <Stack direction={{ xs: 'row', md: 'column' }} spacing={spacing[4]}>
          {subsites.map((subsite) => {
            // search is only available when there's a home page
            const homePage = subsite.homePage!;
            return (
              <SubsiteLink
                key={subsite.id}
                parentSubsite={parentSubsite}
                icon={subsite.icon}
                label={subsite.publicName}
                url={homePage.url}
              />
            );
          })}
        </Stack>
      </ScrollArea>
    </div>
  );
}
